import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import CircularProgress from 'material-ui/CircularProgress';
import { TranscriptsLoaderStyle, Container } from '@layout/DashboardPage';
import { OrganizationsPageTemplate } from '@templates';
import { OrganizationsTable } from '@organisms';
import messages from './messages';
import { OrganizationFilters } from '@molecules';
import { Pagination } from '@atoms';

export default class OrganizationsPage extends PureComponent {
  static propTypes = {
    loadOrganozationsList: PropTypes.func.isRequired,
    updateOrganizationStarted: PropTypes.func.isRequired,
    updateOrganizationEnd: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired,
    setFilterField: PropTypes.func.isRequired,
    changePage: PropTypes.func.isRequired,
    list: PropTypes.array,
    isFetching: PropTypes.bool,
    filter: PropTypes.object,
  };

  static defaultProps = {
    isFetching: false,
  };

  componentWillMount() {
    this.props.loadOrganozationsList();
  }

  componentWillUnmount() {
    this.props.clearFilter();
  }

  render() {
    const { isFetching, filter, setFilterField } = this.props;
    const { name, currentPage, totalPages } = filter;

    return (
      <OrganizationsPageTemplate title={<FormattedMessage {...messages.title} />}>
        <Container>
          <OrganizationFilters
            setFilterField={setFilterField}
            filterNameField={name}
            applyFilter={() => {
              this.props.loadOrganozationsList();
            }}
          />
          <Pagination
            id="organizations-table-pagination"
            current={currentPage}
            total={totalPages}
            onChange={(pageNumber) => {
              this.props.changePage({ currentPage: pageNumber });
            }}
          />
        </Container>
        <OrganizationsTable {...this.props} sortByOrder={() => {}} />
        {isFetching && <CircularProgress style={TranscriptsLoaderStyle} />}
      </OrganizationsPageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/OrganizationsPage/OrganizationsPage.js